export const AUTH_ROUTE_NAMES = {
  ROOT: 'authentication',
  DEFAULT: '',
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  RESET_PASSWORD: 'reset-password',
  TOS: 'tos',
  DENIED: 'denied',
} as const;
